import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";

export type KYMW6901Tab = typeof KYMW6901Model.TAB_PROPOSAL | typeof KYMW6901Model.TAB_MASTER_INPUT;
export type KYMW6901DisplayMode = typeof KYMW6901Model.DISPLAY_MODE_REGIST | typeof KYMW6901Model.DISPLAY_MODE_UPDATE;

export class KYMW6901Model {
  static readonly DISPLAY_MODE_REGIST = '0';
  static readonly DISPLAY_MODE_UPDATE = '1';

  static readonly TAB_PROPOSAL = '0';
  static readonly TAB_MASTER_INPUT = '1';

  static readonly ASSOCIATED_USER_TYPE_SUPPLIER = KYMW00Model.ASSOCIATED_USER_TYPE_SUPPLIER;
  static readonly USER_CLASS_LEADER = '0';
  static readonly USER_CLASS_STAFF = '1';
  static readonly USER_CLASS_AGENT = '2';


  proposalId = '';
  proposalStatus = '';
  masterInputId = '';
  defaultTab: KYMW6901Tab = '0';
  mode: KYMW6901DisplayMode = '0';
  pCode = '';
  itemCode = '';
  classCode = '';

  selectedTabIndex = 0;

  // kymw6900の検索条件
  searchProposalStatus = '';
  searchClassCode = '';
  searchProposalUserId = '';
  searchBuyerId = '';
  searchGoodsAndStandardName = '';
  searchStartOrderCode = '';
  searchDelivCatalogId = '';
  searchPCode = '';
  searchMasterInputStatus = '';

  get kymw6900SearchParams(): any {
    return {
      searchProposalStatus: this.searchProposalStatus,
      searchClassCode: this.searchClassCode,
      searchProposalUserId: this.searchProposalUserId,
      searchBuyerId: this.searchBuyerId,
      searchGoodsAndStandardName: this.searchGoodsAndStandardName,
      searchStartOrderCode: this.searchStartOrderCode,
      searchDelivCatalogId: this.searchDelivCatalogId,
      searchPCode: this.searchPCode,
      searchMasterInputStatus: this.searchMasterInputStatus
    }
  }


  showMasterInputTab() {
    this.selectedTabIndex = 1;
  }

}